import { prettyFormatNumber } from '@helios/utils'
import { WorkbenchRow } from '../../models/workbench-row.model'
import {
  statusPanelTemplate,
  WorkbenchStatusBarBase,
} from './workbench-status-bar-base'

const CONTAINER_ID = 'wb-units-container'

/** `Units: <total>` for the current selection, mirroring the classic transactions status bar. */
export class WorkbenchUnitsStatusBarComp extends WorkbenchStatusBarBase {
  constructor() {
    super(
      statusPanelTemplate(
        'Units',
        `<span id="${CONTAINER_ID}">-</span>`,
        'hs-workbench-units-status-bar',
      ),
    )
  }

  protected render(rows: WorkbenchRow[]): void {
    this.setEmptyState(rows.length === 0)

    const units = rows.reduce((total, row) => total + (row.units ?? 0), 0)
    const container = this.eGui.querySelector(`#${CONTAINER_ID}`)
    if (container != null) {
      container.innerHTML = prettyFormatNumber(units, 4)
    }
  }
}
